import { EnvironmentInjector } from '@angular/core';

export let environmentInjector: EnvironmentInjector | null = null;

export function setEnvironmentInjector(injector: EnvironmentInjector) {
    environmentInjector = injector;
}
